// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:08
import { TrafficIncidentResult_abstract } from './../abstract/SagaBase/TrafficIncidentResult_abstract';
export class TrafficIncidentResult extends TrafficIncidentResult_abstract {}
